<template>
  <BlocoFormularioCadastro voltar="/" @salvar="salvar()">
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-1">
          <div class="radio">
            <label>
              <input
                v-model="buscarPor"
                data-test-id="input-buscarpor-paciente"
                type="radio"
                value="P"
                @click="limparGuiaOuPaciente()"
              />
              Paciente
            </label>
          </div>
          <div class="radio">
            <label>
              <input
                v-model="buscarPor"
                data-test-id="input-buscarpor-guia"
                type="radio"
                value="G"
                @click="limparGuiaOuPaciente()"
              />
              Guia
            </label>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-7">
          <div style="margin-top: 10px">
            <BuscarSelecionarGuia
              v-if="buscarPor === 'G'"
              v-tooltip="'Número da guia do paciente'"
              :minimo="1"
              :exibe-label="false"
              @selecionadoGuia="selecionarGuia($event)"
              @limparGuia="limparGuiaOuPaciente"
            />
            <BuscarSelecionarPaciente
              v-else-if="buscarPor === 'P'"
              v-tooltip="'Nome do paciente'"
              :minimo="1"
              :exibe-label="false"
              @selecionadoPaciente="selecionarPaciente($event)"
              @limparPaciente="limparGuiaOuPaciente"
            />
          </div>
        </div>
        <div
          v-if="outrasGuias.length"
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
        >
          <select
            id="selecionarOutrasGuias"
            v-model="guia"
            v-tooltip="'Guias enviadas para faturamento'"
            data-test-id="select-selecionaroutrasguias"
            class="form-control"
            style="margin-top: 10px"
            @change="selecionarOutraGuia"
          >
            <option disabled selected value=""> Selecione </option>
            <option
              v-for="g in outrasGuiasEnviadasParaFaturamento"
              :key="g._id"
              :value="g"
            >
              {{ g.autorizacao.numeroGuia }} -
              {{ ultimoHistoricoGuia(g.historico) }}
            </option>
          </select>
        </div>
      </div>
      <!-- Informações da guia -->
      <div v-if="guia._id" class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="guia-secao-titulo">Informações da guia</div>
          <div class="guia-secao">
            <div class="guia-informacao-grupo">
              <div class="guia-informacao">
                <div class="guia-informacao-titulo"> Guia </div>
                <div class="guia-informacao-valor">
                  {{ guia.autorizacao.numeroGuia }}
                </div>
              </div>
              <div class="guia-informacao">
                <div class="guia-informacao-titulo"> Paciente </div>
                <div class="guia-informacao-valor">
                  {{ guia.beneficiario.nome }}
                </div>
              </div>
              <div class="guia-informacao">
                <div class="guia-informacao-titulo"> Convênio </div>
                <div class="guia-informacao-valor">
                  {{ guia.beneficiario.convenio.nome }}
                </div>
              </div>
              <div class="guia-informacao">
                <div class="guia-informacao-titulo"> Emissão </div>
                <div class="guia-informacao-valor">
                  {{ formatarData(guia.autorizacao.dataEmissao, 'DD/MM/YYYY') }}
                </div>
              </div>
              <div class="guia-informacao">
                <div class="guia-informacao-titulo"> Autorização </div>
                <div class="guia-informacao-valor">
                  {{
                    formatarData(guia.autorizacao.dataAutorizacao, 'DD/MM/YYYY')
                  }}
                </div>
              </div>
              <div class="guia-informacao">
                <div class="guia-informacao-titulo"> Último histórico </div>
                <div class="guia-informacao-valor">
                  {{ ultimoHistoricoGuia(guia.historico) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-9">
          <div class="guia-secao-titulo">Procedimentos</div>
          <table class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>Tabela</th>
                <th>Procedimento</th>
                <th>Solicitado</th>
                <th>Realizado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(procedimento, index) in guia.solicitacao.procedimentos"
                :key="procedimento._id"
              >
                <td>
                  <select
                    v-model="procedimento.codigoTabela"
                    data-test-id="select-procedimento-codigotabela"
                    class="form-control input-sm"
                  >
                    <option disabled value="">Selecione</option>
                    <option
                      v-for="tabela in guia.beneficiario.convenio.tabelas"
                      :key="tabela._id"
                      :value="tabela.nome"
                      >{{ tabela.nome }}</option
                    >
                  </select>
                </td>
                <td>
                  <BuscarSelecionarProcedimento
                    :exibe-label="false"
                    :classes-input="'form-control input-sm'"
                    :convenio="guia.beneficiario.convenio"
                    :tabela="procedimento.codigoTabela"
                    :exibir-chave="false"
                    :exibir="['codigoNome']"
                    :selecionado="procedimento"
                    :minimo="1"
                    @selecionadoProcedimento="
                      aoSelecionarProcedimento(index, $event)
                    "
                    @limparProcedimento="limparProcedimento()"
                  />
                </td>
                <td>
                  <input
                    v-model="procedimento.qtdSolicitada"
                    v-mask="'999'"
                    data-test-id="input-procedimento-qtdsolicitada"
                    type="number"
                    class="form-control input-sm"
                    @change="aoAlterarQuantidadeSolicitada(index, procedimento)"
                  />
                </td>
                <td>
                  <input
                    v-model="
                      guia.procedimentosRealizados.procedimentos[index]
                        .qtdRealizada
                    "
                    v-mask="'999'"
                    data-test-id="input-guia-procedimentosrealizados-procedimentos-index-qtdrealizada"
                    type="number"
                    class="form-control input-sm"
                    @change="aoAlterarQuantidadeRealizada(index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table
            v-if="guia.agendamentos.length"
            class="table table-striped table-hover table-bordered"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Data / Hora</th>
                <th>Especialidade</th>
                <th>Unidade</th>
                <th>Profissional</th>
                <th>Status</th>
                <th>Faturamento</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(agendamento, index) in guia.agendamentos"
                :key="`${index}_${agendamento._id}`"
              >
                <td>{{ index + 1 }}</td>
                <td
                  >{{ formatarData(agendamento.data, 'DD/MM/YYYY') }}
                  {{ agendamento.hora }}</td
                >
                <td>{{ agendamento.especialidade }}</td>
                <td>{{ agendamento.unidade }}</td>
                <td>{{
                  agendamento.profissional
                    ? agendamento.profissional.nome
                    : 'Não informado'
                }}</td>
                <td
                  :class="
                    'status_agendamento agendamento-legenda-item--' +
                    agendamento.status
                  "
                  >{{ agendamento.status }}</td
                >
                <td>
                  <div style="width: 12rem" class="input-group input-group-sm">
                    <input
                      v-model="agendamento.faturamento"
                      v-mask="'99/99/9999'"
                      data-test-id="input-agendamento-faturamento"
                      readonly
                      type="text"
                      class="form-control"
                    />
                    <span class="input-group-btn">
                      <button
                        data-test-id="button-limpardatafaturamento-8"
                        type="button"
                        class="btn btn-primary"
                        @click="limparDataFaturamento(agendamento)"
                      >
                        <span class="fa fa-times" />
                      </button>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="well"> A guia não possui agendamentos. </div>
          <div>
            <div class="guia-secao-titulo">Observação</div>
            <textarea
              v-model="guia.observacaoFaturamento"
              data-test-id="textarea-guia-observacaofaturamento"
              class="form-control"
              rows="3"
            />
          </div>
          <div>
            <div class="guia-secao-titulo">Adicionar ao pacote</div>

            <SelecionarGenerico
              id="pacoteFaturamento"
              :valores="pacotes"
              :opcao-sem-valor="novoPacoteFaturamentoNome"
              :valor="pacoteFaturamento._id"
              descricao="nome"
              @atualizar="atualizarPacoteFaturamento"
            />
          </div>
        </div>
        <div
          style="height: 700px"
          class="col-md-4 col-lg-3 hidden-sm hidden-xs"
        >
          <div class="pull-right selecionar-faturamento">
            <DatePicker
              v-if="guia.agendamentos.length"
              v-model="dataFaturamento"
              :today-btn="false"
              :clear-btn="false"
              :format="'dd/MM/yyyy'"
              :close-on-selected="true"
              :date-parser="dataParser"
              :date-class="dataClasse"
              class="date-picker"
              @input="selecionarDataFaturamento($event)"
            />
            <div v-if="outrasGuiasEmAndamento.length" style="margin-left: 12px">
              <h3 class="guia-secao-titulo">Em andamento</h3>
              <table class="table table-bordered table-hover table-condensed">
                <tbody>
                  <tr v-for="g in outrasGuiasEmAndamento" :key="g._id">
                    <td>
                      <button
                        data-test-id="button-guia-g-selecionaroutraguia-10"
                        type="button"
                        class="btn btn-link"
                        @click="aoSelecionarGuiaEmAndamento(g)"
                      >
                        {{ g.autorizacao.numeroGuia }}
                      </button>
                    </td>
                    <td>
                      {{ ultimoHistoricoGuia(g.historico) }}
                    </td>
                  </tr>
                </tbody>
              </table></div
            >
          </div>
        </div>
      </div>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import numeral from 'numeral'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import BuscarSelecionarGuia from '@/componentes/formulario/BuscarSelecionarGuia'
import BuscarSelecionarPaciente from '@/componentes/formulario/BuscarSelecionarPaciente'
import BuscarSelecionarProcedimento from '@/componentes/formulario/BuscarSelecionarProcedimento'
import SelecionarGenerico from '@/componentes/formulario/SelecionarGenerico'
import { useMenu } from '@/composables/useMenu'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import FaturamentoServico from '@/servicos/FaturamentoServico'
import GuiaServico from '@/servicos/GuiaServico'
import MensagemServico from '@/servicos/MensagemServico'
import appStore from '@/stores'
import * as formatadores from '@/utils/formatadores'

const guiaServico = new GuiaServico()
const agendamentoServico = new AgendamentoServico()
const mensagemServico = new MensagemServico()
const faturamentoServico = new FaturamentoServico()

export default {
  name: 'FaturamentoGuia',
  components: {
    BuscarSelecionarGuia,
    BuscarSelecionarPaciente,
    BuscarSelecionarProcedimento,
    BlocoFormularioCadastro,
    SelecionarGenerico,
  },
  directives: { mask: AwesomeMask },

  setup() {
    useMenu(45)
  },

  data() {
    return {
      buscarPor: 'P',
      paciente: {},
      guia: {},
      outrasGuias: [],
      dataFaturamento: new Date(),
      observacaoFaturamentoGuia: '',
      pacoteFaturamento: {
        _id: '',
      },
      pacotes: [],
    }
  },
  computed: {
    novoPacoteFaturamentoNome() {
      return `${moment().format('YYYY_MMMM_ww_X').toUpperCase()} (Novo)`
    },
    outrasGuiasEmAndamento() {
      return this.outrasGuias.filter((g) => !g.bloqueada)
    },
    outrasGuiasEnviadasParaFaturamento() {
      return this.outrasGuias.filter((g) => g.bloqueada)
    },
  },
  created() {
    this.recuperarPacotesAtivos()
  },
  methods: {
    ...formatadores,
    aoSelecionarProcedimento(index, procedimento) {
      this.atualizarProcedimento(index, procedimento)
    },
    aoAlterarQuantidadeSolicitada(index, procedimento) {
      this.atualizaProcedimentoSolicitado(index, procedimento)
      this.atualizaTotalGuia()
    },
    aoAlterarQuantidadeRealizada(index) {
      const procedimento =
        this.guia.procedimentosRealizados.procedimentos[index]

      this.atualizaProcedimentoRealizado(index, procedimento)
      this.atualizaTotalGuia()
    },
    aoSelecionarGuiaEmAndamento(guia) {
      this.guia = guia
      this.selecionarOutraGuia()
    },
    atualizarPacoteFaturamento(pacoteId) {
      this.pacoteFaturamento = this.pacotes.find((p) => p._id === pacoteId)
    },
    atualizarProcedimento(index, procedimentoNovo) {
      procedimentoNovo.valorFixo = procedimentoNovo.valor_fixo
      this.atualizaProcedimentoSolicitado(index, procedimentoNovo)
      this.atualizaProcedimentoRealizado(index, procedimentoNovo)
      this.atualizaTotalGuia()
    },
    atualizaProcedimentoSolicitado(index, procedimentoNovo) {
      const procedimentoSolicitado = this.guia.solicitacao.procedimentos[index]

      procedimentoSolicitado.codigo = procedimentoNovo.codigo
      procedimentoSolicitado.codigoNome = procedimentoNovo.codigoNome
      procedimentoSolicitado.nome = procedimentoNovo.nome
      procedimentoSolicitado.valorFixo = procedimentoNovo.valorFixo
      procedimentoSolicitado.ch = procedimentoNovo.ch
    },
    atualizaProcedimentoRealizado(index, procedimentoNovo) {
      const procedimentoRealizado =
        this.guia.procedimentosRealizados.procedimentos[index]

      procedimentoRealizado.codigo = procedimentoNovo.codigo
      procedimentoRealizado.codigoNome = procedimentoNovo.codigoNome
      procedimentoRealizado.nome = procedimentoNovo.nome
      procedimentoRealizado.valorFixo = procedimentoNovo.valorFixo
      procedimentoRealizado.ch = procedimentoNovo.ch

      let vu = procedimentoNovo.ch
        ? procedimentoNovo.ch * this.guia.beneficiario.convenio.valorCH
        : procedimentoNovo.valorFixo
      procedimentoRealizado.valorUnitario = vu

      vu = numeral(procedimentoRealizado.valorUnitario).value()
      const qtd = numeral(procedimentoRealizado.qtdRealizada).value()
      const valorTotal = vu * qtd
      procedimentoRealizado.valorTotal = valorTotal
    },
    atualizaTotalGuia() {
      let totalProcedimentos
      if (this.guia.procedimentosRealizados.fixarValor) {
        totalProcedimentos = this.procedimentosRealizados.totalProcedimentos
      } else {
        let soma = numeral()

        this.guia.procedimentosRealizados.procedimentos.forEach((p) => {
          if (
            !p.vazio &&
            !/AVALIACAO/i.test(p.nome) &&
            !/AVALIAÇÃO/i.test(p.nome)
          ) {
            const vu = numeral(p.valorUnitario)
            soma = soma.add(vu.value())
          }
        })

        const fm = numeral(this.guia.procedimentosRealizados.fatorMultiplicador)
        totalProcedimentos = soma.multiply(fm.value())
      }

      this.guia.procedimentosRealizados.totalProcedimentos =
        numeral(totalProcedimentos).value()
    },
    limparProcedimento() {},
    selecionarGuia(evento) {
      if (evento.bloqueada) {
        this.guia = evento
        this.recuperarAgendamentosGuia()
        this.processarProcedimentos()
        this.recuperarGuiasPaciente(this.guia.beneficiario._id)
      } else {
        mensagemServico.alerta('A guia informada não pode ser faturada.')
      }
    },
    processarProcedimentos() {
      this.guia.solicitacao.procedimentos.forEach((procedimento) => {
        procedimento.codigoNome = `${procedimento.codigo} - ${procedimento.nome}`
      })
    },
    selecionarPaciente(evento) {
      this.paciente = evento
      guiaServico
        .recuperarTodos({
          pacienteId: evento._id,
          skip: 0,
        })
        .then((result) => {
          this.outrasGuias = result.guias
          this.guia = this.outrasGuias.find((g) => g.bloqueada)

          if (this.guia) {
            this.processarProcedimentos()
            this.recuperarAgendamentosGuia()
          } else {
            mensagemServico.alerta(
              'O paciente informado não possui nenhuma guia para faturar.'
            )
          }
        })
    },
    limparGuiaOuPaciente() {
      this.guia = {}
      this.paciente = {}
      this.outrasGuias = []
    },
    salvar() {
      this.salvarDatasFaturamento()
      this.salvarGuia()

      const destino = this.$router.resolve({ name: 'FaturamentoGuia' })

      if (destino.fullPath !== this.$route.fullPath) {
        this.$router.replace(destino)
      }
    },
    salvarGuia() {
      const guiaAtualizada = { ...this.guia }
      guiaAtualizada.agendamentos = this.guia.agendamentos.map((a) => a._id)

      if (!guiaAtualizada.historico || !guiaAtualizada.historico.length) {
        guiaAtualizada.historico = []
      }

      guiaAtualizada.historico.push({
        codigo: 3,
        descricao: `Faturamento dos agendamentos`,
        dataCriacao: new Date(),
        criadoPor: appStore.usuario.email,
      })

      guiaServico.atualizar(guiaAtualizada._id, guiaAtualizada)
    },
    salvarDatasFaturamento() {
      const dados = this.guia.agendamentos
        .filter((a) => a.faturamento)
        .map((a) => {
          return {
            _id: a._id,
            faturamento: moment(a.faturamento, 'DD/MM/YYYY').format(
              'YYYY-MM-DD'
            ),
          }
        })

      if (dados.length) {
        agendamentoServico.adicionarDatasFaturamento(dados)
      }

      if (this.pacoteFaturamento._id) {
        dados.map((d) => {
          const dataAgendamento = this.pacoteFaturamento.datasAgendamentos.find(
            (da) => da.agendamento === d._id
          )

          if (dataAgendamento) {
            dataAgendamento.datas.push(d.faturamento)
          } else {
            this.pacoteFaturamento.datasAgendamentos.push({
              agendamento: d._id,
              datas: [d.faturamento],
            })
          }
        })
      } else {
        this.pacoteFaturamento = {
          nome: moment().format('YYYY_MMMM_ww').toUpperCase(),
          ativo: true,
          guias: [this.guia],
          datasAgendamentos: dados.reduce((a, c) => {
            const dataAgendamento = a.find((a1) => a1.agendamento === c._id)

            if (dataAgendamento) {
              dataAgendamento.datas.push(c.faturamento)
            } else {
              a.push({
                agendamento: c._id,
                datas: [c.faturamento],
              })
            }
            return a
          }, []),
        }
      }

      if (this.pacoteFaturamento._id) {
        faturamentoServico.atualizar(
          this.pacoteFaturamento._id,
          this.pacoteFaturamento
        )
      } else {
        faturamentoServico.criar(this.pacoteFaturamento)
      }
    },
    ultimoHistoricoGuia(historico) {
      if (!historico.length) {
        return 'Sem dados.'
      }

      const ultimoHistorico = historico.reduce((acumulador, atual, index) =>
        atual.dataCriacao > acumulador.dataCriacao && index ? atual : acumulador
      )

      return `${ultimoHistorico.descricao}, em ${moment(
        ultimoHistorico.dataCriacao
      ).format('DD/MM/YYYY')}.`
    },
    selecionarOutraGuia() {
      this.recuperarAgendamentosGuia()
      this.processarProcedimentos()
    },
    recuperarGuiasPaciente(pacienteId) {
      guiaServico
        .recuperarTodos({
          pacienteId: pacienteId,
          skip: 0,
        })
        .then((result) => {
          this.outrasGuias = result.guias
        })
    },
    async recuperarAgendamentosGuia() {
      const res = await guiaServico.recuperarAgendamentos({
        guiaId: this.guia._id,
        skip: 0,
        limit: 20,
      })
      this.guia.agendamentos = res.agendamentos

      const agendamentosBuffer = []

      for (const a of this.guia.agendamentos) {
        if (a.faturamento) {
          const faturamento = moment.utc(a.faturamento)

          if (faturamento.isValid()) {
            a.faturamento = faturamento.format('DD/MM/YYYY')
          } else {
            const result = await faturamentoServico.recuperarTodos({
              nome: a.faturamento,
            })

            if (
              result.faturamentos &&
              result.faturamentos.length &&
              result.faturamentos[0]
            ) {
              this.pacoteFaturamento = result.faturamentos[0]

              const dataAgendamento =
                this.pacoteFaturamento.datasAgendamentos.find(
                  (pf) => pf.agendamento === a._id
                )

              const dataIndex = agendamentosBuffer.includes(a._id) ? 1 : 0
              const data =
                dataAgendamento && dataAgendamento.datas
                  ? dataAgendamento.datas[dataIndex] || dataAgendamento.datas[0]
                  : null

              if (data) {
                a.faturamento = moment.utc(data).format('DD/MM/YYYY')
                agendamentosBuffer.push(a._id)
              }
            }
          }
        }
      }
    },
    recuperarPacotesAtivos() {
      faturamentoServico.recuperarTodos({ ativo: true }).then((res) => {
        this.pacotes = res.faturamentos
        return res.faturamentos
      })
    },
    selecionarDataFaturamento(event) {
      if (event) {
        this.dataFaturamento = event
      }

      const mesmaData = this.guia.agendamentos.find(
        (agendamento) => agendamento.faturamento === this.dataFaturamento
      )

      const proximoAgendamento = this.guia.agendamentos.find(
        (agendamento) => !agendamento.faturamento
      )

      if (
        mesmaData &&
        mesmaData.especialidade === proximoAgendamento.especialidade
      ) {
        mensagemServico.alerta(
          `Data ${this.dataFaturamento} já selecionada para ${mesmaData.especialidade}.`
        )
        return
      }

      agendamentoServico
        .checarDisponibilidadeDataFaturamento({
          pacienteId: this.guia.beneficiario._id,
          dataFaturamento: moment(this.dataFaturamento, 'DD/MM/YYYY').format(
            'YYYY-MM-DD'
          ),
          especialidade: this.guia.especialidade,
        })
        .then((res) => {
          if (res.disponivel) {
            this.guia.agendamentos.every((agendamento) => {
              if (agendamento.faturamento) {
                return true
              } else {
                this.$set(agendamento, 'faturamento', this.dataFaturamento)
                return false
              }
            })
          } else {
            this.dataFaturamento = ''
            mensagemServico.alerta(
              'Data não está disponível. ' +
                'Já existe um Agendamento Faturado para esta Data ' +
                moment.utc(res.agendamento.faturamento).format('DD/MM/YYYY') +
                ' e para a especialidade ' +
                res.agendamento.especialidade
            )
          }
        })
    },
    limparDataFaturamento(agendamento) {
      this.$set(agendamento, 'faturamento', '')
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
    dataClasse(date) {
      if (
        this.guia.agendamentos.find((agendamento) =>
          moment(agendamento.faturamento, 'DD/MM/YYYY').isSame(date)
        )
      ) {
        return 'text-danger'
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped>
.guia-secao {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.guia-secao-titulo {
  margin-top: 22px;
  margin-bottom: 6px;
  font-size: 1.8em;
}

.guia-informacao-grupo {
  display: flex;
  flex-flow: row nowrap;
}

.guia-informacao {
  padding: 6px 10px;
  margin: 6px 22px 6px 0;
  background-color: #ecf0f1;
  border-left: 8px solid #008080;
  transition: box-shadow 0.3s;
}

.guia-informacao:hover {
  box-shadow: 0 0 4px rgba(33, 33, 33, 0.2);
}

.guia-informacao-titulo {
  font-size: 0.9em;
  font-weight: bolder;
  text-align: right;
  text-transform: uppercase;
}

.guia-informacao-valor {
  font-size: 1.3em;
}

.table td {
  vertical-align: middle !important;
}

.selecionar-faturamento {
  position: sticky;
  top: 100px;
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>
